@if (isLoading) {
<app-loading-spinner [text]="'Negotiations'"></app-loading-spinner>
} @if (negotiation; as data) {
<div class="py-2 px-4 page-height overflow-auto">
  <div class="flex justify-center items-center">
    <div class="text-xl font-medium text-white">
      {{ data.commodity }} -
      {{ data.grade }}
    </div>
  </div>
  <mat-card
    appearance="outlined"
    class="my-card border-none rounded-md py-5 my-1 py mb-18 mx-auto max-w-xl"
  >
    <mat-card-content class="rounded-md my-1 w-100 text-gray-500 font-medium">
      <form [formGroup]="updateNegotiationInput" (ngSubmit)="onSubmit()">
        <div class="flex flex-row gap-4 flex-wrap justify-center items-center">
          <mat-form-field appearance="outline">
            <mat-label>Price</mat-label>
            <input
              matInput
              type="number"
              formControlName="price_value"
              [placeholder]="data.counters[0]['price_value'] | priceType"
            />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Volume</mat-label>
            <input
              matInput
              type="number"
              formControlName="volume_value"
              [placeholder]="data.counters[0]['volume_value']"
            />
          </mat-form-field>
          <!-- Shipping Date Field -->
          <mat-form-field
            id="date-range-field"
            appearance="outline"
            style="max-width: 212px !important"
          >
            <mat-label>Delivery Window</mat-label>
            <mat-date-range-input [rangePicker]="picker" [min]="minDate">
              <input
                matStartDate
                formControlName="ship_begin"
                placeholder="Start date"
                [errorStateMatcher]="matcher"
              />
              <input
                matEndDate
                formControlName="ship_end"
                placeholder="End date"
                [errorStateMatcher]="matcher"
              />
            </mat-date-range-input>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker touchUi #picker></mat-date-range-picker>
            <mat-hint class="text-gray-400 text-sm">mm/dd/yy</mat-hint>
          </mat-form-field>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
  <div class="my-card rounded-md px-7 py-5 my-2 mb-18 mx-auto max-w-xl">
    <div class="flex justify-between items-center">
      <div class="">DETAILS</div>
      <div class="text-gray-400 text-xs">
        Originated As
        <mat-chip-set class="flex flex-row pl-2 items-start">
          <mat-chip-option
            style="margin-left: 4px !important"
            disableRipple="true"
            [ngClass]="{
              'blue-chip': data.lot_type === 'Offer',
              'green-chip': data.lot_type === 'Bid'
            }"
          >
            {{ data.lot_type }}
          </mat-chip-option>
        </mat-chip-set>
      </div>
    </div>
    <div class="my-4">
      <div class="my-2">
        <div class="pb-3"></div>
        <div class="grid grid-cols-2 gap-4 items-center">
          <div class="text-xs text-gray-400">Original Price</div>
          <div class="text-xs text-gray-400">Original Quantity</div>
        </div>
        <div class="grid grid-cols-2 gap-4 items-center mb-2">
          <div class="text-md font-medium">
            {{ data.currency }} ${{ data.price_value_orig | priceType }}
            /
            {{ data.units }}
          </div>
          <div class="text-md font-medium">
            {{ data.volume_value_orig }}
            {{ data.units == "Metric Tonnes" ? "MT" : data.units }}
          </div>
        </div>
      </div>
      <div class="my-4">
        <div class="grid grid-cols-2 gap-4 items-center">
          <div class="text-md text-gray-400">Delivery Type</div>
          <div class="text-md text-gray-400">Tolerance</div>
        </div>
        <div class="grid grid-cols-2 gap-4 items-center mb-2">
          <div class="text-lg font-medium">
            {{ data.delivery_type }}
          </div>
          <div class="text-lg font-medium">
            {{ data.tolerance }}
          </div>
        </div>
      </div>
      <div class="my-2">
        <div class="my-3">
          <div class="text-md text-gray-400">Location</div>
          <div class="text-lg font-medium">
            {{ data.destination }}
          </div>
        </div>
        <div class="my-3">
          <div class="text-md text-gray-400">Original Shipping</div>
          <div class="text-lg font-medium">
            @if ( data.ship_begin == null && data.ship_end == null) {
            <div>
              {{ data.ship_begin_orig | date : "MMM d, y" }} -
              {{ data.ship_end_orig | date : "MMM d, y" }}
            </div>
            } @else {
            <div>
              {{ data.ship_begin | date : "MMM d, y" }} -
              {{ data.ship_end | date : "MMM d, y" }}
            </div>
            }
          </div>
        </div>
        <div class="my-3">
          <div class="text-md text-gray-400">Condition</div>
          <div class="text-lg font-medium">
            {{ data.condition }}
          </div>
        </div>
      </div>
      <div class="absolute bottom-4 left-0 right-0 flex justify-center">
        <button
          class="button-transition bg-custom-blue text-white text-md p-4 rounded-full flex items-center justify-center w-40"
          type="submit"
          [style.opacity]="buttonOpacity"
          (click)="onSubmit()"
        >
          Submit
        </button>
        <!-- </a> -->
      </div>
    </div>
  </div>
  <div class="h-16"></div>
</div>
}
